export default __webpack_public_path__ + "static/boat-84fec207a87d9814f0857ece856e15f1.svg";